import styled from 'styled-components';

import { text } from 'quarks/interpolations/text';

const Paragraph = styled.p`
  ${text}
`;

export default Paragraph;
